export const screen1 = "emailContentScreen";
export const screen2 = "doneInstructionsSentScreen";

export const FORGOT_PASSWORD_STEPS = [screen1, screen2];
